export const API_ROUTES = {
  getAdditionalQualifications: 'get-additional-qualifications',
  getService: 'get-services',
  insertFocusQualifications: 'insert-focus-qualifications',
  updateSpeciality: 'update-speciality',
  insertQualifications: 'insert-qualifications',
  getSpecialistQualificationList: 'get-specialist-qualification-list',
  getDoctorManagementDetails: 'get-doctor-management-details',
  deleteQualifications: 'delete-qualifications',
  insertAdditionalQualifications: 'insert-additional-qualifications',
  insertTreatmentService: 'insert-billable-services',
  getTreatmentQualifications: 'get-treatment-qualifications',
  deleteBillableServices: 'delete-billable-services',
  updateServiceQualifications: 'update-service-qualifications',
  getDoctorVerificationDetails: 'v2/get-user-details-doctor-verification-by-id',
  getDoctorVerificationList: 'v3/get-practise-user-verification-details-by-status',
  getDoctorVerificationStats: 'v2/get-doctor-verification-stats',
  getRoleManagementStats: '/v2/get-role-management-stats',
  getAdminRoleManagementList: 'v2/get-practise-user-details-by-role-assigned-and-status',
  getPractiseAdminRoleManagementList: 'v2/get-practise-user-details-by-role',
  updateProfessionalDetailsVerificationStatus: 'update-professional-details-verification-status',
  updateIdDocumentsVerificationStatus: 'update-id-documents-verification-status',
  updateLivePictureVerificationStatus: 'update-live-picture-verification-status',
  updateOrgVerificationStatus: 'update-organisation-details-status',
  getPractiseCode: 'v1/get-practice-code',
  // role-management
  insertPractiseDepartments: 'v2/insert-practise-departments',
  insertPractiseAdminDepartments: 'v1/insert-practise-admin-departments',
  insertPractiseOrganisations: 'v2/insert-practise-organisations',
  insertUserPractiseMapping: 'v1/insert-user-practise-mapping',
  getPracticeDepartments: 'v1/get-practise-departments',
  updatePractiseUserRole: 'v1/update-practise-user-role',

  // patient management
  getPatientsStats: 'v1/get-patient-management-stats-data',
  getAppointmentTrends: 'v1/get-appointment-booking-trends',
  getRegistrationTrends: 'v2/get-patient-management-registration-trend',
  getVerificationTrends: 'v2/get-patient-management-verification-trend',
  getPatientsList: 'v1/get-patient-users-patient-management',
  getPatientProfileDetailsById: 'v1/get-patient-profile-details-by-id',

  //ask for update
  askForUpdateProfessionalDetails: 'v2/ask-for-update-professional-details-verification-status',
  askForUpdateMedicalDocument: 'v2/ask-for-update-id-documents-verification-status',
  askForUpdateLivePicture: 'v2/ask-for-update-live-picture-verification-status',
  askForUpdateOrganisationDetails: 'v1/ask-for-update-organisation-details-verification-status',

  //reject
  rejectProfile: 'v2/reject-user-verification-profile',
  //overall
  updatePractiseOverAllVerificationStatus: 'v2/update-practise-all-verification-status',
  setStatusAfterRole: 'v1/update-practise-user-role-assigned-status',

  //profile
  getLivePicture: 'v1/get-practise-user-image',
  insertLivePic: 'insert-practise-user-live-picture',
  updateLivePic: 'update-practise-user-live-picture',
  //doctor-management
  getDoctorProfileCompletionDetails: 'v2/get-doctor-profile-completion-details',
  getDoctorRegistrationTrends: 'v2/get-doctor-registration-trends',
  getDoctorProfileDetailsById: 'v2/get-doctor-profile-details-by-id',
  getSlotsByDateAndId: 'v1/get-practise-slots-by-date-and-id',
  getAppointmentsByDateAndId: 'v1/get-doctor-appointments-by-date-and-id',
  getSlotsDatesByRange: 'v1/get-practise-user-slot-dates-by-range',
  getDoctorManagementStatCardsData: 'v1/get-doctor-management-stat-cards-data',

  //dashboard
  getDashboardStatCardsData: 'v1/get-dashboard-stat-cards-data',
  getDashboardStatCardsDataPractiseAdmin: 'v1/get-dashboard-stat-cards-data-practise-admin',
  getUsersRegistrationTrends: 'v2/get-users-registration-trends',
  getUserVerificationTrend: 'v2/get-user-verification-trend',
  getUserCurrentTrends: 'v2/get-user-current-trends',
  getTotalActiveUsersData: 'v1/get-total-active-users-data',
  getEngagementRatesData: 'v2/get-engagement-rates-data',

  // organisation
  // dashboad
  getOrganisationDashboardActivity: 'v1/get-organisation-activity-data',
  getOrganisationDashboardLineActivity: 'v1/get-new-organisations-active-count',
  getOrganisationStats: 'v1/get-organisation-management-stats',

  //details
  getOrganisationDetails: 'v1/get-practise-admin-profile-home-page-details-by-id',
  getAllOrganisationDetails: 'v1/get-staff-members-details-by-role-and-id',
  getOrganisationActivityDetails: '/v1/get-organisation-activity-details',

  //profile
  updateOrgLogo: 'v1/insert-practise-organisation-logo',
  getPractiseAdminOrganisationDetailsById: 'v1/get-practise-admin-organisation-details-by-id',
  updateOrgDetails: 'v1/update-practice-admin-organisation-details',

  // hasura base call :
  hasuraGraphql: 'v1/graphql',

  // s3-presigned url
  fetchPresignedUrl: 'v1/generate-fetch-presigned-url',
  uploadPresignedUrl: 'v1/generate-upload-presigned-url',

  //breath-training
  getBreathTrainingDashboardData: 'v1/breath-training-home-page-data',
  markBreathTrainingRowAsImportant: 'v1/mark-breath-training-important',
  updateBreathTrainingComment: 'v1/update-breath-training-comment'
};
